import React, { useEffect, useState } from "react";
import { SubStateVM } from "../../../Models/ViewModels";
import { GetUserLoginID } from "../../../Services/UserSessionManager";
import { ToastContainer, toast } from 'react-toastify';
import ModalHeader from "rsuite/esm/Modal/ModalHeader";
import ModalTitle from "rsuite/esm/Modal/ModalTitle";
import ModalBody from "rsuite/esm/Modal/ModalBody";
import { Button, Input, Modal } from "rsuite";
import { AddSubState, DeleteSubState, EditSubState } from "../../../Services/SubStateDB";
import { GetProcessDetails,GetActionDetails, GetPayerDetails } from "../../../Services/ProcessDB";
import { act } from "@testing-library/react";
type attributes = {
 
    type:string,
    title:string  , 
    data:SubStateVM;
    onAction: any;
    cachedData:Array<SubStateVM>;
  }

  export const AddEditDeleteSubState=(props:attributes)=>{
    const[loginid,setLoginid]=useState(GetUserLoginID())
    const[newSubstate,setNewSubstate]=useState(new SubStateVM())
    const [open, setOpen] = React.useState(true);
  const [displayButton,setDisplayButton]=useState(false)
    const[process,SetProcess]=useState([])
    const[action,setAction]=useState([])
    const[payer,setPayer]=useState([])

  useEffect(() => {
    setNewSubstate(props.data)
    if(props.type=='edit')
    {
      setDisplayButton(true)
    }
    GetProcessName();
    GetActions();
    GetPayer();
  }, []) 
    const handleClose = () =>{
        setOpen(false);
        }
        console.log(payer)
    const handelAccountModification=()=>{
        if(props.type=='edit'){
            EditSubState(newSubstate,loginid).then((res)=>{
                if(res.data==1){
                props.onAction();
                handleClose();
                   toast.info("Updated successfully !");}
                else{
                    toast.error("Updated Failed !");
                }
            }).catch((err)=>{
                toast.error("Failed to Update !");}
            )
        }

         else if(props.type=='add'){
            AddSubState(newSubstate,loginid).then((res)=>{
              if(res.data==1){
                props.onAction();
                handleClose();
                 toast.success("Added successfully")
              }
              else
                toast.error("Failed to Add!")
            }).catch((err)=>{
                toast.error("Failed to Add !")
            })
        }
        else if(props.type=='delete'){
            DeleteSubState(newSubstate.SubStateId).then((res)=>{
                props.onAction();
                handleClose();
               toast.error("Deleted successfully")
            }).catch((err)=>{
                toast.error("Failed to Delete !");
            })
        }
    }
    const GetActions=()=>{
      GetActionDetails().then((res)=>{
         setAction(res.data)
      })
  }
  const GetPayer=()=>{
    GetPayerDetails().then((res)=>{
       setPayer(res.data)
    })
}
    const GetProcessName=()=>{
        GetProcessDetails().then((res)=>{
           SetProcess(res.data)
        })
    }
    const handleInput = (value:any,event:any) => {
        console.log(event)
        let value1 = event.target.type === 'number' ? +event.target.value : event.target.value;
        setNewSubstate({...newSubstate, [event.target.name]:value1});
        
    }
    console.log(newSubstate)

    const handleInputDropDown = (event:any) => {
        let value = event.target.type === 'number' ? +event.target.value : event.target.value;
        setNewSubstate({...newSubstate, [event.target.name]:value});
  
    }
    if(props.type=='delete'){
        return(
        <div className="modal-container">
       <ModalHeader>
         <ModalTitle><h4>{props.title}</h4></ModalTitle>
       </ModalHeader>
       <ModalBody>
        Are you sure you want to delete {newSubstate.SubStateName}
       </ModalBody>
       <Modal.Footer>
              <Button onClick={handelAccountModification} appearance="primary">
              Delete
              </Button>
            </Modal.Footer>
       </div>
        )
      }
    else{
        return (
            <div className="modal-container"> 
                <Modal.Header>
                  <Modal.Title><h3>{props.title}</h3></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <ModalTitle >SubState Name</ModalTitle>
                <Input  type="text" name="SubStateName" value={newSubstate.SubStateName} onChange={(value,event)=>handleInput(value,event)}/>
                <ModalTitle>ProcessName</ModalTitle>
                <select id="select" 
                style={{width:360,height:37,borderRadius:5,borderColor:"#e3e0d3"}}
                  name="ProcessName" 
                  value={newSubstate.ProcessName}
                  onChange={handleInputDropDown}
               >
             <option className="bg-secondary text-light">Select-Process</option>
                           {
             process.map((prr:any)=>{
                 if(prr===null)
                 return(<></>)
                 else if(prr.IsActive==="Active"){
                    return(
                        <option value={prr.ProcessName}>{prr.ProcessName}</option>
                    )
                 }
                })
             }
       
         </select>
                <ModalTitle >Case Type</ModalTitle>
                <Input className="form-control" type="text" name="CaseType" value={newSubstate.CaseType} onChange={(value,event)=>handleInput(value,event)}/>
               
                <ModalTitle>PayerName</ModalTitle>
               
               <select style={{width:360,height:37,borderRadius:5,borderColor:"#e3e0d3"}} id="select" 
                 name="Payer" 
                 value={newSubstate.Payer}
                 onChange={handleInputDropDown}
              >
            <option >Select-Payer</option>
                          {
            payer.map((prr:any)=>{
                if(prr===null)
                return(<></>)
                else {
                   return(
                       <option value={prr.PayerName}>{prr.PayerName}</option>
                   )
                }
               })
            }
      
        </select>
       
        
        <ModalTitle>Action</ModalTitle>
               <select id="select" 
               style={{width:360,height:37,borderRadius:5,borderColor:"#e3e0d3"}}
                 name="Action" 
                 value={newSubstate.Action}
                 onChange={handleInputDropDown}
             >
            <option className="bg-secondary text-light">Select-Action</option>
                          {
            action.map((prr:any)=>{
                if(prr===null)
                return(<></>)
                else {
                   return(
                       <option value={prr.ActionName}>{prr.ActionName}</option>
                   )
                }
               })
            }
      
        </select>
                        <ModalTitle >VC From State</ModalTitle>
                <Input   className="form-control"type="text" name="VCFromState" value={newSubstate.VCFromState} onChange={(value,event)=>handleInput(value,event)}/>
                <ModalTitle >VC To State</ModalTitle>
                <Input type="text" name="VCToState" value={newSubstate.VCToState} onChange={(value,event)=>handleInput(value,event)}/>
               
                </Modal.Body>
                
                {displayButton?
                    <Modal.Footer> <Button onClick={handelAccountModification} appearance="primary">
                    Update
                    </Button> 
                    </Modal.Footer>
                    :
                    <Modal.Footer><Button onClick={handelAccountModification} appearance="primary">
                     Add
                    </Button>
                    </Modal.Footer>
                }
            </div>
        )
                
    }
     
  }